import React, { useEffect, useState, useContext } from "react";
import "./CompanyList.css";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Button,
  Modal,
  Box,
  TextField,
  Stepper,
  Step,
  StepButton,
  Typography,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Table,
  StepLabel,
  TableBody,
  TableCell,
  Card,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItemIcon,
} from "@mui/material";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import PersonIcon from "@mui/icons-material/Person";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CallMissedOutgoingIcon from "@mui/icons-material/CallMissedOutgoing";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import PhoneIcon from "@mui/icons-material/Phone";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import UpdateIcon from "@mui/icons-material/Update";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import CategoryIcon from "@mui/icons-material/Category";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import MinimizeIcon from "@mui/icons-material/Minimize";
import IconButton from "@mui/material/IconButton";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ClientEnquiryForm from "./ClientEnquiryForm";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { toast, ToastContainer } from "react-toastify";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import DrawerComponent from "./common/DrawerComponent";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";
import { SendEmailModal } from "./SendEmailModal ";

const CompanyList = () => {
  const { user_id, role } = useContext(UserContext);
  const [companies, setCompanies] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [products, setProducts] = useState([]);
  const [services, setServices] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const buttons = [
    "Qualified",
    "Demo Schedule",
    "Sales Qualified",
    "Negotiation",
    "Deal",
    "Lost",
  ];
  const [showProductList, setShowProductList] = useState(false);
  const [showServiceList, setShowServiceList] = useState(false);
  const [showCompanyList, setShowCompanyList] = useState(false);
  const [showIndustryList, setShowIndustryList] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedCompanyType, setSelectedCompanyType] = useState([]);
  const [selectedIndustryType, setSelectedIndustryType] = useState([]);

  // --- NEW: State for separate quick filters ---
  const [globalProductFilter, setGlobalProductFilter] = useState("");
  const [globalServiceFilter, setGlobalServiceFilter] = useState("");

  const [companyType, setCompanyType] = useState([]);
  const [industryType, setIndustryType] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [edit, setEdit] = useState(null);
  const [currentDate, setCurrentDate] = useState(getFormattedDate());
  const [selected, setSelected] = useState("Qualified");
  const [isLoading, setIsLoading] = useState(false);
  const [sidebars, setSidebars] = useState([]);
  const [roleId, setRoleId] = useState(null);
  const [followUpDate, setFollowUpDate] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [isEmailSending, setIsEmailSending] = useState({});

  // State for Documents
  const [documentsModalOpen, setDocumentsModalOpen] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [selectedCompanyForDocs, setSelectedCompanyForDocs] = useState(null);

  // State for Preview
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewSrc, setPreviewSrc] = useState("");
  const [previewType, setPreviewType] = useState(" "); // 'image' or 'pdf'
  const handleSendMail = (company) => {
    setSelectedCompany(company);
    setOpenModal(true);
  };
  const steps = [
    "Qualified",
    "Demo Schedule",
    "Sales Qualified",
    "Negotiation",
    "Deal",
    "Lost",
  ];
  const getActiveStep = () => {
    const index = steps.findIndex((step) => step === selected);
    return index !== -1 ? index : 0;
  };
  const ColorlibStepIcon = ({ icon, active }) => {
    const icons = {
      1: <CheckCircleOutlineIcon />, // Qualified
      2: <ScheduleIcon />, // Demo Schedule
      3: <ThumbUpAltOutlinedIcon />, // Sales Qualified
      4: <HandshakeOutlinedIcon />, // Negotiation
      5: <EmojiEventsOutlinedIcon />, // Deal
      6: <CancelOutlinedIcon />, // Lost
    };

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 60,
          height: 60,
          borderRadius: "50%",
          backgroundColor: active ? "#fb7102" : "#e0e0e0",
        }}
      >
        {icons[icon]}
      </div>
    );
  };

  function getFormattedDate() {
    const now = new Date();
    const day = now.toLocaleString("en-US", { weekday: "short" });
    const month = now.toLocaleString("en-US", { month: "short" });
    const date = now.toLocaleString("en-US", { day: "2-digit" });
    const year = now.getFullYear();
    const time = now.toLocaleString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${day}, ${month} ${date}, ${year} ${time}`;
  }

  useEffect(() => {
    async function fetchRoleId() {
      if (!role) return;
      try {
        const response = await axios.get(`/api/get-role-id/`, {
          params: { role_name: role },
        });
        setRoleId(response.data.role_id);
      } catch (error) {
        console.error("Error fetching role id:", error);
        toast.error("Failed to fetch role id");
      }
    }
    fetchRoleId();
  }, [role]);

  const fetchCompanyType = async () => {
    try {
      const response = await axios.get("api/company-types/");
      setCompanyType(response.data);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const fetchIndustryType = async () => {
    try {
      const response = await axios.get("api/industry-types/");
      setIndustryType(response.data);
    } catch (error) {
      console.log("Error", error);
    }
  };
  useEffect(() => {
    fetchCompanyType();
    fetchIndustryType();
  }, []);

  useEffect(() => {
    async function fetchSidebarPermissions() {
      if (!roleId) return;
      setIsLoading(true);
      try {
        const response = await axios.get(`/api/sidebars/role/${roleId}/`);
        setSidebars(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching sidebar permissions:", error);
        toast.error("Failed to fetch sidebar permissions");
      } finally {
        setIsLoading(false);
      }
    }
    fetchSidebarPermissions();
  }, [roleId]);

  const addProductSidebar = sidebars.find(
    (item) => item.action_link === "/CompanyList"
  );

  const rolePermissions = addProductSidebar?.roles.find(
    (role) => role.role_id === roleId
  )?.permissions;
  const [filterValue, setFilterValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const filterOptions = ["Demo Schedule", "Sales Qualified", "Qualified"];

  const handleToggleFilters = () => {
    setShowFilters(!showFilters);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(getFormattedDate());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const statusMap = {
    "Sales Qualified": "Sales Qualified",
    Qualified: "Qualified",
    Negotiation: "Negotiation",
    "Demo Schedule": "Demo Schedule",
    Deal: "Deal",
    Lost: "Lost",
  };

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "api";

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("api/products/");
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);
  const handlePdfDownload = async () => {
    try {
      const params = new URLSearchParams();
      if (filterValue) params.append("filter_value", filterValue);
      if (startDate) params.append("start_date", startDate);
      if (endDate) params.append("end_date", endDate);

      const response = await axios.get(
        `/api/filtered-enquiries-pdf/?${params.toString()}`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `enquiries_${filterValue || "all"}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get("api/services/");
        setServices(response.data);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  const handleOpenTCODocuments = async (company) => {
    setSelectedCompanyForDocs(company);
    try {
      // Assuming your backend endpoint is /api/tco-documents/
      // This returns list of SentTCO objects
      const response = await axios.get(
        `/api/TCO-documents/?company_id=${company.export_company}`
      );

      // Map the data to ensure it works with your existing List UI
      // SentTCO has 'pdf_file', while EnquiryFile has 'file'.
      // We normalize them here.
      const mappedDocs = response.data.map((doc) => ({
        ...doc,
        file: doc.pdf_file, // Rename pdf_file to file for compatibility
        file_name:
          doc.file_name ||
          `TCO_Sent_${new Date(doc.sent_at).toLocaleDateString()}`,
      }));

      setDocuments(mappedDocs);
      setDocumentsModalOpen(true);
    } catch (error) {
      console.error("Error fetching TCO documents:", error);
      toast.error("Failed to load TCO documents.");
    }
  };

  // --- UPDATED: filteredCompanies Logic ---
  const filteredCompanies = companies.filter((company) => {
    // 1. Status Filter (Existing)
    const filterStatus = statusMap[selected]
      ? statusMap[selected].trim().toLowerCase()
      : null;
    const companyStatus = company.status
      ? company.status.trim().toLowerCase()
      : null;
    if (filterStatus && companyStatus !== filterStatus) {
      return false;
    }

    // 2. Sidebar Product Filter (Existing)
    if (selectedProducts.length > 0) {
      const companyProductIds = company.products
        ? company.products.map((p) => p.id)
        : [];
      const match = selectedProducts.some((selProd) =>
        companyProductIds.includes(selProd.id)
      );
      if (!match) return false;
    }

    // 3. Sidebar Service Filter (Existing)
    if (selectedServices.length > 0) {
      const companyServiceIds = company.services
        ? company.services.map((s) => s.id)
        : [];
      const match = selectedServices.some((selServ) =>
        companyServiceIds.includes(selServ.id)
      );
      if (!match) return false;
    }

    // 4. NEW: Global Product Select Filter
    if (globalProductFilter) {
      const companyProductIds = company.products
        ? company.products.map((p) => p.id)
        : [];
      if (
        !companyProductIds.includes(
          parseInt(globalProductFilter) || globalProductFilter
        )
      ) {
        return false;
      }
    }

    // 5. NEW: Global Service Select Filter
    if (globalServiceFilter) {
      const companyServiceIds = company.services
        ? company.services.map((s) => s.id)
        : [];
      if (
        !companyServiceIds.includes(
          parseInt(globalServiceFilter) || globalServiceFilter
        )
      ) {
        return false;
      }
    }

    // 6. Company Type Filter (Existing)
    if (selectedCompanyType.length > 0) {
      const match = selectedCompanyType.some(
        (selServ) => selServ.id === company.company_type
      );
      if (!match) return false;
    }

    // 7. Industry Type Filter (Existing)
    if (selectedIndustryType.length > 0) {
      const match = selectedIndustryType.some(
        (selServ) => selServ.id === company.industry_type
      );
      if (!match) return false;
    }

    // 8. Follow-up Date Filter (Existing)
    if (followUpDate) {
      if (!company.folowed_date) {
        return false;
      }
      const companyDate = dayjs(company.folowed_date);
      if (!followUpDate.isSame(companyDate, "day")) {
        return false;
      }
    }

    // 9. Lost Type Filter (Existing)
    if (filterValue) {
      if (!company.needs) {
        return false;
      }
      const companyDate = company.needs;
      if (companyDate !== filterValue) {
        return false;
      }
    }

    return true;
  });

  const fetchCompanies = async () => {
    setLoading(true);
    setError(null);

    const params = new URLSearchParams();
    params.append("role", role);
    params.append("id", user_id);
    params.append("assigned_to_ids", user_id);

    try {
      const response = await fetch(`/api/companies/?${params.toString()}`);

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();
      setCompanies(data);
    } catch (error) {
      console.error("Failed to fetch companies:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, [user_id, role]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  const handleFilter = () => {
    setOpenFilter((prev) => !prev);
  };

  const handleOpenDocuments = async (company) => {
    setSelectedCompanyForDocs(company);
    try {
      // 1. Fetch existing Enquiry Files
      const enquiryResponse = await axios.get(`/api/enquiry-files/?company_id=${company.id}`);
      // Map to standard keys that match your UI logic
      const enquiryFiles = enquiryResponse.data.map((file) => ({
        ...file,
        file: file.file || file.document, // Handle field name variations
        file_name: file.file_name || file.file?.split('/').pop(),
        sent_at: file.uploaded_at // Rename 'uploaded_at' to 'sent_at' so UI works consistently
      }));

      // 2. Fetch Sent Product Emails History
      let productFiles = [];
      try {
        const productResponse = await axios.get(`/api/sent-product-emails/?company_id=${company.export_company}`);
        const sentEmails = productResponse.data;

        // 3. Flatten data (One email has multiple files)
        sentEmails.forEach((email) => {
          // Your Serializer generates 'file_urls'. If you haven't updated serializer yet, check 'attached_files'
          const fileUrls = email.file_urls || email.attached_files;
          
          if (fileUrls && Array.isArray(fileUrls)) {
            fileUrls.forEach((url) => {
              // Create a standardized object for each file
              productFiles.push({
                id: `prod-${email.id}-${Math.random()}`, // Unique ID for the list
                file: url, // The URL for preview
                file_name: url.split('/').pop() || 'Product Document', // Extract filename
                sent_at: email.sent_at // Keep the email's timestamp
              });
            });
          }
        });
      } catch (prodError) {
        console.log("No product emails found or endpoint not ready:", prodError);
      }

      // 4. Combine both lists (Enquiry Files + Product Files)
      const allDocuments = [...enquiryFiles, ...productFiles];
      setDocuments(allDocuments);
      setDocumentsModalOpen(true);

    } catch (error) {
      console.error("Error fetching documents:", error);
      toast.error("Failed to load documents.");
    }
  };

  const handleCloseDocuments = () => {
    setDocumentsModalOpen(false);
    setDocuments([]);
  };
      // Define file types for Office documents
  const officeExts = ["doc", "docx", "ppt", "pptx", "xls", "xlsx","pdf"];

  // Helper: Fix double /media/ issue (Same as ProductManagement)
  const getCleanFullUrl = (fileUrl) => {
    if (!fileUrl) return "";
    if (fileUrl.startsWith("http://") || fileUrl.startsWith("https://")) return fileUrl;
    
    // Fix: Prevents /media/media/...
    if (fileUrl.includes("/media/")) {
      return `/api/${fileUrl}`;
    }
    
    return `/api/media/${fileUrl}`;
  };

  // Helper: Backend Preview Endpoint (Assumes you have this API endpoint)
  const getPdfPreviewUrl = (originalUrl) => {
    console.log("Previewing Office Doc:", originalUrl);
    // Remove leading '/media/' for the backend request
    const relativePath = originalUrl.replace(/^\/media\//, "");
    return `/api/preview-batch-pdf?file=${encodeURIComponent(relativePath)}`;
  };

       const handlePreviewDocument = async (fileUrl, fileName) => {
  const fullUrl = getCleanFullUrl(fileUrl); 
  
  const fileExt = fullUrl.split('.').pop().toLowerCase();
  
  console.log("Preview Check - URL:", fullUrl, "Ext:", fileExt, "Name:", fileName);
  
  const getPdfPreviewUrl = (originalUrl) => {
  console.log("Previewing Office Doc:", originalUrl);
  const urlPath = originalUrl.replace(/^https?:\/\/[^/]+/, '');
  const relativePath = urlPath.replace(/^\/media\//, "");
  return `/api/preview-batch-pdf?file=${encodeURIComponent(relativePath)}`;
};
  // 1. Handle PDF
  if (fileExt === "pdf") {
    setPreviewType("pdf");
    setPreviewSrc(fullUrl);
    setPreviewModalOpen(true);
    return;
  }
  // 2. Handle Images
  if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExt)) {
  setPreviewType("image");
  setPreviewSrc(fullUrl);
  setPreviewModalOpen(true);
  return;
}
  // 3. Handle Text Files
  if (fileExt === "txt") {
    setPreviewType("txt");
    setPreviewSrc(fullUrl);
    setPreviewModalOpen(true);
    return;
  }

  // 4. Handle Office/Other Files
  const previewUrl = getPdfPreviewUrl(fullUrl);
  setPreviewType("pdf"); // Assuming the backend returns a PDF preview
  setPreviewSrc(previewUrl);
  setPreviewModalOpen(true);
};


  const handleClosePreview = () => {
    setPreviewModalOpen(false);
    setPreviewSrc("");
  };

  const handleNavigate = async (id) => {
    try {
      const response = await axios.get(`/api/client-enquiry/${id}/`);
      const enquiry = response.data;
      if (enquiry) {
        console.log(enquiry,"enquiry");
        navigate(`/timeline/${enquiry.id}/${enquiry.company_id}/${enquiry.export_company}`);
      }
      
      
    } catch (error) {
      console.log("error");
    }
  };

  return (
    <Box className="main-container">
      <ToastContainer />
      <div className="header-row">
        <Box className="header-title-container">
          <LiveHelpIcon className="live-help-icon" />
          <span className="Title">Enquiry</span>
        </Box>
        <span className="current-dates">{currentDate}</span>
      </div>
      <Box className="status-button-group">
        <Stepper
          activeStep={getActiveStep()}
          alternativeLabel
          nonLinear
          sx={{
            width: "100%",
            "& .MuiStepConnector-line": {
              marginTop: "20px",
            },
          }}
        >
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                StepIconComponent={() => (
                  <ColorlibStepIcon
                    icon={index + 1}
                    active={getActiveStep() === index}
                  />
                )}
                onClick={() => setSelected(label)}
                sx={{
                  cursor: "pointer",
                  "& .MuiStepLabel-label": {
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "grey",
                    "&.Mui-active": {
                      color: "#fb7102",
                    },
                    "&.Mui-completed": {
                      color: "#fb7102",
                    },
                  },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <Box className="Company_content-container">
        <IconButton
          onClick={handleFilter}
          aria-label="Open filters"
          className="filter-icon-button"
          style={{ alignSelf: "flex-start" }}
        >
          <FilterListIcon />
        </IconButton>
        {openFilter && (
          <Box className="filter-sidebar">
            <Box className="filter-section">
              <Box
                className="filter-header"
                onClick={() => setShowProductList((prev) => !prev)}
              >
                <p className="service_name">Product</p>
                {showProductList ? (
                  <MinimizeIcon className="toggle-icon" />
                ) : (
                  <AddIcon />
                )}
              </Box>
              {showProductList && (
                <Box className="filter-list">
                  {products.map((prod) => {
                    const isSelected = selectedProducts.some(
                      (p) => p.id === prod.id
                    );
                    return (
                      <Box
                        key={prod.id}
                        className={`filter-item ${
                          isSelected ? "selected" : ""
                        }`}
                        onClick={() => {
                          setSelectedProducts((prev) =>
                            isSelected
                              ? prev.filter((p) => p.id !== prod.id)
                              : [...prev, prod]
                          );
                        }}
                      >
                        <span className="expend_product">
                          {prod.product_name}
                        </span>
                        {isSelected && (
                          <span className="selected-check">✔</span>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
            <Box className="filter-section">
              <Box
                className="filter-header"
                onClick={() => setShowServiceList((prev) => !prev)}
              >
                <p className="service_name">Service</p>
                {showServiceList ? (
                  <MinimizeIcon className="toggle-icon" />
                ) : (
                  <AddIcon />
                )}
              </Box>
              {showServiceList && (
                <Box className="filter-list">
                  {services.map((serv) => {
                    const isSelected = selectedServices.some(
                      (s) => s.id === serv.id
                    );
                    return (
                      <Box
                        key={serv.id}
                        className={`filter-item ${
                          isSelected ? "selected" : ""
                        }`}
                        onClick={() => {
                          setSelectedServices((prev) =>
                            isSelected
                              ? prev.filter((s) => s.id !== serv.id)
                              : [...prev, serv]
                          );
                        }}
                      >
                        <span className="expend_product">
                          {serv.service_name}
                        </span>
                        {isSelected && (
                          <span className="selected-check">✔</span>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
            <Box className="filter-section">
              <Box
                className="filter-header"
                onClick={() => setShowCompanyList((prev) => !prev)}
              >
                <p className="service_name">CompanyType</p>
                {showCompanyList ? (
                  <MinimizeIcon className="toggle-icon" />
                ) : (
                  <AddIcon />
                )}
              </Box>
              {showCompanyList && (
                <Box className="filter-list">
                  {companyType.map((serv) => {
                    const isSelected = selectedCompanyType.some(
                      (s) => s.id === serv.id
                    );
                    return (
                      <Box
                        key={serv.id}
                        className={`filter-item ${
                          isSelected ? "selected" : ""
                        }`}
                        onClick={() => {
                          setSelectedCompanyType((prev) =>
                            isSelected
                              ? prev.filter((s) => s.id !== serv.id)
                              : [...prev, serv]
                          );
                        }}
                      >
                        <span className="expend_product">{serv.name}</span>
                        {isSelected && (
                          <span className="selected-check">✔</span>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
            <Box className="filter-section">
              <Box
                className="filter-header"
                onClick={() => setShowIndustryList((prev) => !prev)}
              >
                <p className="service_name">IndustryType</p>
                {showIndustryList ? (
                  <MinimizeIcon className="toggle-icon" />
                ) : (
                  <AddIcon />
                )}
              </Box>
              {showIndustryList && (
                <Box className="filter-list">
                  {industryType.map((serv) => {
                    const isSelected = selectedIndustryType.some(
                      (s) => s.id === serv.id
                    );
                    return (
                      <Box
                        key={serv.id}
                        className={`filter-item ${
                          isSelected ? "selected" : ""
                        }`}
                        onClick={() => {
                          setSelectedIndustryType((prev) =>
                            isSelected
                              ? prev.filter((s) => s.id !== serv.id)
                              : [...prev, serv]
                          );
                        }}
                      >
                        <span className="expend_product">{serv.name}</span>
                        {isSelected && (
                          <span className="selected-check">✔</span>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
            <Box className="filter-section">
              <Box
                className="filter-header"
                onClick={() => setShowDatePicker((prev) => !prev)}
              >
                <p className="service_name">Follow-up Date</p>
                <CalendarTodayIcon className="toggle-icon" />
              </Box>
              {showDatePicker && (
                <Box sx={{ p: 1, mt: 1 }}>
                  <DatePicker
                    label="Select a date"
                    value={followUpDate}
                    onChange={(newValue) => {
                      setFollowUpDate(newValue);
                    }}
                    slotProps={{
                      textField: { size: "small", fullWidth: true },
                    }}
                  />
                </Box>
              )}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                <Box
                  onClick={handleToggleFilters}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <p className="service_name" style={{ margin: 0 }}>
                    Lost Type
                  </p>
                  {showFilters ? (
                    <MinimizeIcon className="toggle-icon" />
                  ) : (
                    <AddIcon />
                  )}
                </Box>

                {showFilters && (
                  <>
                    <select
                      value={filterValue}
                      onChange={(e) => setFilterValue(e.target.value)}
                      style={{
                        backgroundColor: "#FFD68A",
                        borderRadius: "4px",
                        border: "none",
                        height: "35px",
                        padding: 0,
                      }}
                    >
                      <option value="">Select Type</option>
                      {filterOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>

                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <p>
                        <b>Start Date</b>
                      </p>
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        style={{
                          backgroundColor: "#FFD68A",
                          borderRadius: "4px",
                          border: "none",
                        }}
                      />
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <p>
                        <b>End Date</b>
                      </p>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        style={{
                          backgroundColor: "#FFD68A",
                          borderRadius: "4px",
                          border: "none",
                        }}
                      />
                    </Box>

                    <Box sx={{ marginTop: "auto" }}>
                      <PictureAsPdfIcon
                        sx={{ cursor: "pointer", color: "#d32f2f" }}
                        onClick={handlePdfDownload}
                        fontSize="large"
                      />
                    </Box>
                  </>
                )}
              </Box>
            </Box>
            {(selectedProducts.length > 0 ||
              selectedServices.length > 0 ||
              selectedCompanyType.length > 0 ||
              selectedIndustryType.length > 0 ||
              followUpDate) && (
              <Box className="reset-filter-container">
                <Button
                  variant="contained"
                  color="warning"
                  startIcon={<RestartAltIcon />}
                  onClick={() => {
                    setSelectedProducts([]);
                    setSelectedServices([]);
                    setSelectedIndustryType([]);
                    setSelectedCompanyType([]);
                    setShowDatePicker(false);
                    setFollowUpDate(null);
                  }}
                  className="reset-filter-btn"
                >
                  Reset Filter
                </Button>
              </Box>
            )}
          </Box>
        )}

        {/* company-list this is in flex direction column */}
        <Box className={`company-list ${openFilter ? "with-filter" : ""}`}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              flexWrap: "wrap",
              padding: "10px",
              borderRadius: "4px",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            {/* Product Select */}
            <FormControl size="small" sx={{ minWidth: 160 }}>
              <InputLabel id="product-filter-label">Product</InputLabel>
              <Select
                labelId="product-filter-label"
                value={globalProductFilter}
                label="Product"
                onChange={(e) => setGlobalProductFilter(e.target.value)}
              >
                <MenuItem value="">
                  <em>All Products</em>
                </MenuItem>
                {products.map((prod) => (
                  <MenuItem key={prod.id} value={prod.id}>
                    {prod.product_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Service Select */}
            <FormControl size="small" sx={{ minWidth: 160 }}>
              <InputLabel id="service-filter-label">Service</InputLabel>
              <Select
                labelId="service-filter-label"
                value={globalServiceFilter}
                label="Service"
                onChange={(e) => setGlobalServiceFilter(e.target.value)}
              >
                <MenuItem value="">
                  <em>All Services</em>
                </MenuItem>
                {services.map((serv) => (
                  <MenuItem key={serv.id} value={serv.id}>
                    {serv.service_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Clear Quick Filters Button */}
            {(globalProductFilter || globalServiceFilter) && (
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => {
                  setGlobalProductFilter("");
                  setGlobalServiceFilter("");
                }}
                sx={{ height: 40 }}
              >
                Clear
              </Button>
            )}
          </Box>

          {/* add new class name and need to be in flex direction Row */}
          <Box className="cards-row-container">
            {filteredCompanies.length === 0 ? (
              <Box className="no-data">
                <Typography variant="h6" color="textSecondary">
                  No Data found for the selected filters.
                </Typography>
              </Box>
            ) : (
              <>
                {filteredCompanies.map((company) => {
                  const firstProduct =
                    (company.products &&
                      company.products.length > 0 &&
                      company.products[0]) ||
                    (company.services &&
                      company.services.length > 0 &&
                      company.services[0]) ||
                    null;

                  const backgroundColor =
                    firstProduct && firstProduct.color
                      ? firstProduct.color
                      : "#f5f5f5";
                  let imgUrl = null;
                  if (firstProduct && firstProduct.img) {
                    imgUrl = firstProduct.img.startsWith("/media")
                      ? `${BACKEND_URL}${firstProduct.img}`
                      : firstProduct.img;
                  }

                  return (
                    <Card
                      key={company.id}
                      className="company-card"
                      style={{ backgroundColor }}
                    >
                      <CardContent className="card-content">
                        <Box className="card-header">
                          <Box>
                            {imgUrl ? (
                              <img
                                src={imgUrl}
                                alt={firstProduct.name || "Product Image"}
                                className="product-image"
                              />
                            ) : (
                              <Typography variant="body2" color="textSecondary">
                                None
                              </Typography>
                            )}
                          </Box>
                          <Typography variant="body1" className="enquiry-info">
                            <CallMissedOutgoingIcon className="info-icon green" />
                            <strong className="enquiry_details">
                              Enquiry Id:
                            </strong>
                            <span className="enquiry_details">
                              {company.enquiry_id}
                            </span>
                          </Typography>
                        </Box>

                        <Typography variant="body1" className="enquiry-info">
                          <HeadphonesIcon className="info-icon purple" />
                          <strong className="enquiry_details">Company :</strong>
                          <strong className="enquiry_details">
                            {company.name}
                          </strong>
                        </Typography>
                        <Typography variant="body1" className="enquiry-info">
                          <PhoneIcon className="info-icon green" />
                          <strong className="enquiry_details">Contact :</strong>
                          <strong className="enquiry_details">
                            {company.mobile_number}
                          </strong>
                        </Typography>
                        <Typography variant="body1" className="enquiry-info">
                          <EventAvailableIcon className="info-icon blue" />
                          <strong className="enquiry_details">
                            Followed Date :
                          </strong>
                          <span className="enquiry_details">
                            {company.folowed_date
                              ? new Date(
                                  company.folowed_date
                                ).toLocaleDateString()
                              : "Not Scheduled"}
                          </span>
                        </Typography>
                        <Typography variant="body1" className="enquiry-info">
                          <UpdateIcon className="info-icon red" />
                          <strong className="enquiry_details">
                            Last Updated At :
                          </strong>
                          <span className="enquiry_details">
                            {company.last_updated_at
                              ? new Date(
                                  company.last_updated_at
                                ).toLocaleDateString()
                              : "Not Scheduled"}
                          </span>
                        </Typography>
                        {selected === "Lost" && (
                          <Typography
                            variant="subtitle1"
                            className="enquiry-info"
                          >
                            <ProductionQuantityLimitsIcon className="info-icon pink" />
                            <strong className="enquiry_details">
                              Enquiry Status :
                            </strong>
                            <span className="enquiry_details">
                              {company.needs}
                            </span>
                          </Typography>
                        )}
                        {company.products && company.products.length > 0 && (
                          <Typography
                            variant="subtitle1"
                            className="enquiry-info"
                          >
                            <CategoryIcon className="info-icon pink" />
                            <strong className="enquiry_details">
                              Products :
                            </strong>
                            <span className="enquiry_details">
                              {company.products
                                .map((prod) => prod.name)
                                .join(", ")}
                            </span>
                          </Typography>
                        )}
                        {company.services && company.services.length > 0 && (
                          <Typography
                            variant="subtitle1"
                            className="enquiry-info"
                          >
                            <AllInclusiveIcon className="info-icon green" />
                            <strong className="enquiry_details">
                              Services :
                            </strong>
                            <span className="enquiry_details">
                              {company.services
                                .map((serv) => serv.name)
                                .join(", ")}
                            </span>
                          </Typography>
                        )}
                        <Box className="enquiry_button-container">
                          {selected === "Sales Qualified" &&
                            company.invoice_generated && (
                              <button
                                className="enquiry_button"
                                onClick={() => handleSendMail(company)}
                                disabled={isEmailSending[company.id]}
                              >
                                {isEmailSending[company.id] ? (
                                  <>
                                    <CircularProgress
                                      size={16}
                                      style={{ color: "white", marginRight: 8 }}
                                    />
                                    Sending...
                                  </>
                                ) : (
                                  "Send Mail"
                                )}
                              </button>
                            )}
                          {!(selected === "Qualified" || selected === "Demo Schedule") && (
  <button
    className="enquiry_button"
    onClick={() => handleOpenTCODocuments(company)}
  >
    TCO
  </button>
)}

                          <button
                            className="enquiry_button"
                            onClick={() => handleOpenDocuments(company)}
                          >
                            View Documents
                          </button>

                          <button
                            className="enquiry_button"
                            onClick={() => handleNavigate(company.id)}
                          >
                            View Details
                          </button>
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() => {
                              if (rolePermissions?.is_update) {
                                setEdit(company);
                                setDrawerOpen(true);
                              } else {
                                toast.error(
                                  "You don't have permission to Edit Enquiry."
                                );
                              }
                            }}
                          >
                            <BorderColorIcon className="edit-icon" />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })}
              </>
            )}
          </Box>
        </Box>
      </Box>
      <DrawerComponent
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
          setEdit(null);
        }}
        title="Client Enquiry Form"
      >
        <ClientEnquiryForm
          onSubmitSuccess={() => {
            setDrawerOpen(false);
            fetchCompanies();
          }}
          edit={edit}
          setEdit={setEdit}
          steps={steps}
          selectedStatus={selected}
        />
      </DrawerComponent>
      <SendEmailModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        company={selectedCompany}
      />
      {/* --- 1. DOCUMENTS LIST MODAL --- */}
      <Dialog
        open={documentsModalOpen}
        onClose={handleCloseDocuments}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ bgcolor: "#fb7102", color: "white" }}>
          Documents for {selectedCompanyForDocs?.name}
        </DialogTitle>
        <DialogContent>
          {documents.length === 0 ? (
            <Typography sx={{ mt: 2, textAlign: "center" }}>
              No documents found.
            </Typography>
          ) : (
            <List sx={{ pt: 0 }}>
              {documents.map((doc) => (
                <ListItem
                  key={doc.id}
                  divider
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="preview"
                      onClick={() =>
                        handlePreviewDocument(
                          doc.file,
                          doc.file_name || doc.file
                        )
                      }
                    >
                      <VisibilityIcon sx={{ color: "#fb7102" }} />
                    </IconButton>
                  }
                >
                  <ListItemIcon>
                    {doc.file_name?.toLowerCase().endsWith(".pdf") ||
                    doc.file?.toLowerCase().endsWith(".pdf") ? (
                      <PictureAsPdfIcon color="error" />
                    ) : (
                      <DescriptionIcon color="primary" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={doc.file_name || doc.file.split("/").pop()}
                    secondary={new Date(doc.sent_at).toLocaleDateString()}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDocuments}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* --- 2. PREVIEW MODAL --- */}
      <Dialog
        open={previewModalOpen}
        onClose={handleClosePreview}
        fullWidth
        maxWidth="lg" // Large width for viewing
        PaperProps={{ sx: { height: "80vh" } }}
      >
        <DialogTitle>
          Document Preview
          <IconButton
            aria-label="close"
            onClick={handleClosePreview}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            bgcolor: "#f5f5f5",
          }}
        >
          {previewType === "image" ? (
            <img
              src={previewSrc}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
            
          ) : (
            <iframe
              src={previewSrc}
              width="100%"
              height="100%"
              style={{ border: "none" }}
              title="PDF Preview"
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default CompanyList;
